import { crmRequest } from '../http'
import type {
  ActivityInput,
  ActivityPatch,
  Planned,
  PlannedTask,
  RelationRef,
  RelationTaskInput,
  ThreadMessage,
  TimelineActivity,
  TimelinePage,
  TimelineType,
} from './types'

function scope(relation: RelationRef, includeMembers?: boolean): URLSearchParams {
  const params = new URLSearchParams(
    relation.kind === 'contact' ? { person_id: relation.id } : { organisation_id: relation.id },
  )
  if (relation.kind === 'organisation' && includeMembers === false) params.set('include_members', 'false')
  return params
}

export function getTimeline(
  relation: RelationRef,
  options: { types?: TimelineType[]; q?: string; cursor?: string | null; limit?: number; includeMembers?: boolean },
  signal?: AbortSignal,
): Promise<TimelinePage> {
  const params = scope(relation, options.includeMembers)
  if (options.types) params.set('types', options.types.join(','))
  if (options.q) params.set('q', options.q)
  if (options.cursor) params.set('cursor', options.cursor)
  if (options.limit) params.set('limit', String(options.limit))
  return crmRequest(`/timeline?${params.toString()}`, { signal })
}

export function getThread(relation: RelationRef, key: string, includeMembers?: boolean): Promise<ThreadMessage[]> {
  const params = scope(relation, includeMembers)
  params.set('key', key)
  return crmRequest(`/timeline/thread?${params.toString()}`)
}

export function getPlanned(relation: RelationRef): Promise<Planned> {
  return crmRequest(`/planned?${scope(relation).toString()}`)
}

export function createActivity(input: ActivityInput): Promise<TimelineActivity> {
  return crmRequest('/activities', { method: 'POST', body: JSON.stringify(input) })
}

export function updateActivity(id: string, patch: ActivityPatch): Promise<TimelineActivity> {
  return crmRequest(`/activities/${id}`, { method: 'PATCH', body: JSON.stringify(patch) })
}

export function deleteActivity(id: string): Promise<void> {
  return crmRequest(`/activities/${id}`, { method: 'DELETE' })
}

export function restoreActivity(id: string): Promise<TimelineActivity> {
  return crmRequest(`/activities/${id}/restore`, { method: 'POST' })
}

export function createRelationTask(input: RelationTaskInput): Promise<PlannedTask> {
  return crmRequest('/tasks', { method: 'POST', body: JSON.stringify(input) })
}
